const getPlacement = (refRect, contentRect, placement = 'bottom-left') => {
    const gap = 4;
    let top;
    let left;
    const middleY = refRect.top + refRect.height / 2 - contentRect.height / 2;
    const middleX = refRect.left + refRect.width / 2 - contentRect.width / 2;
    const fitsBelow = window.innerHeight - refRect.bottom >= contentRect.height + gap;
    const fitsAbove = refRect.top >= contentRect.height + gap;
    switch (placement) {
        case 'top-left':
            top = fitsAbove ? refRect.top - contentRect.height - gap : refRect.bottom + gap;
            left = refRect.left;
            break;
        case 'bottom-left':
            top = fitsBelow ? refRect.bottom + gap : refRect.top - contentRect.height - gap;
            left = refRect.left;
            break;
        case 'top-left-outer':
            top = fitsAbove ? refRect.top - contentRect.height - gap : refRect.bottom + gap;
            left = refRect.left - contentRect.width - gap;
            break;
        case 'top-center':
            top = fitsAbove ? refRect.top - contentRect.height - gap : refRect.bottom + gap;
            left = middleX;
            break;
        case 'bottom-center':
            top = fitsBelow ? refRect.bottom + gap : refRect.top - contentRect.height - gap;
            left = middleX;
            break;
        case 'top-right':
            top = fitsAbove ? refRect.top - contentRect.height - gap : refRect.bottom + gap;
            left = refRect.right - contentRect.width;
            break;
        case 'top-right-outer':
            top = fitsAbove ? refRect.top - contentRect.height - gap : refRect.bottom + gap;
            left = refRect.right + gap;
            break;
        case 'bottom-right':
            top = fitsBelow ? refRect.bottom + gap : refRect.top - contentRect.height - gap;
            left = refRect.right - contentRect.width;
            break;
        case 'bottom-right-outer':
            top = fitsBelow ? refRect.bottom + gap : refRect.top - contentRect.height - gap;
            left = refRect.right + gap;
            break;
        case 'middle-left':
            top = middleY;
            left = refRect.left - contentRect.width - gap;
            break;
        case 'bottom-left-outer':
            top = fitsBelow ? refRect.bottom + gap : refRect.top - contentRect.height - gap;
            left = refRect.left - contentRect.width - gap;
            break;
        case 'middle-right':
            top = middleY;
            left = refRect.right + gap;
            break;
        case 'middle-center':
        default:
            top = middleY;
            left = middleX;
    }
    return {
        position: 'absolute',
        top: top + window.scrollY,
        left: left + window.scrollX,
        zIndex: 9999,
    };
};

export { getPlacement };
